
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donate",
      function () {
        return require("private-next-pages/donate.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/donate"])
      });
    }
  